import { lazy } from "react";
import Home from "../pages/Home";
import Paths from "../utils/Paths";
import Error404 from "../components/common/Error404";

const FAQ = lazy(() => import("../pages/FAQ"));
const SignUp = lazy(() => import("../pages/Authentication/SignUp"));
const SignIn = lazy(() => import("../pages/Authentication/SignIn"));
const GigDetail = lazy(() => import("../pages/Gigs/GigDetail"));
const ViewGigs = lazy(() => import("../pages/Gigs/ViewGigs"));
const SellerDashboard = lazy(() => import("../pages/SellerDashboard/Dashboard"));
const Profile = lazy(() => import("../pages/Profile/Profile"));
const GigCreation = lazy(() => import("../pages/Gigs/GigCreation"));
const Settings = lazy(() => import("../pages/Settings"));
const ManageOrders = lazy(() => import("../pages/Orders/ManageOrders"));
const OrderDetail = lazy(() => import("../pages/Orders/OrderDetail"));
const Forgetpassword = lazy(() => import("../pages/Authentication/ForgetPassword"));
const MobileSso = lazy(() => import("../pages/Authentication/MobileSso"));
const IncomingOffers = lazy(() => import("../pages/Offers/IncomingOffers"));
const SentOffers = lazy(() => import("../pages/Offers/SentOffers"));
const ManageGigs = lazy(() => import("../pages/Gigs/ManageGigs"));
const Payment = lazy(() => import("../pages/Payment"));
const Earnings = lazy(() => import("../pages/Earnings"));
const UpdateGig = lazy(() => import("../pages/Gigs/UpdateGig"));
const BecomeSeller = lazy(() => import("../pages/SellerDashboard/BecomeSeller"));
const SellerOrderDetail = lazy(() => import("../pages/Orders/SellerOrderDetails"));
const Favourites = lazy(() => import("../pages/Favourites"));
const Inbox = lazy(() => import("../pages/Inbox"));
const LegalNDP = lazy(() => import("../pages/Legal/LegalNDP"));
const LegalTOS = lazy(() => import("../pages/Legal/LegalTOS"));
const LegalPP = lazy(() => import("../pages/Legal/LegalPP"));
const LegalPTOS = lazy(() => import("../pages/Legal/LegalPTOS"));
const DeleteAccount = lazy(() => import("../pages/DeleteAccount"));
const PostProject = lazy(() => import("../pages/projects/PostProject"));
const UpdateProject = lazy(() => import("../pages/projects/UpdateProject"));
const ProjectDetail = lazy(() => import("../pages/projects/ProjectDetail"));
const ManageProjects = lazy(() => import("../pages/ManageProjects"));
const EmployerDashboard = lazy(() => import("../pages/EmployerDashboard/Dashboard"));
const BecomeEmployer = lazy(() => import("../pages/EmployerDashboard/BecomeEmployer"));
const PostJob = lazy(() => import("../pages/Jobs/PostJob"));
const UpdateJob = lazy(() => import("../pages/Jobs/UpdateJob"));
const JobDetail = lazy(() => import("../pages/Jobs/JobDetail"));
const ManageJobs = lazy(() => import("../pages/ManageJobs"));
const IncomingCandidates = lazy(() => import("../pages/IncomingCandidates"));
const SubscriptionPlans = lazy(() => import("../pages/EmployerDashboard/SubscriptionPlans"));
const SubscriptionCancel = lazy(() => import("../pages/EmployerDashboard/SubscriptionCancel"));
const SubscriptionSuccess = lazy(() => import("../pages/EmployerDashboard/SubscriptionSuccess"));
const SubscriptionPlansPublic = lazy(() => import("../pages/Public/SubscriptionPlansPublic"));
const CategoryPage = lazy(() => import("../pages/Services/CategoryPage"));

//buyer

//employer

//subscription

// SEO landing pages

export const PrivateRoutes = [
  { path: Paths.seller, component: <SellerDashboard /> },
  { path: Paths.settings, component: <Settings /> },
  { path: Paths.becomeSeller, component: <BecomeSeller /> },
  { path: Paths.becomeEmployer, component: <BecomeEmployer /> },

  { path: Paths.inbox, component: <Inbox /> },
  { path: Paths.favourites, component: <Favourites /> },
  { path: Paths.updateProject, component: <UpdateProject /> },
  { path: Paths.incomingOffers, component: <IncomingOffers /> },
  { path: Paths.buyerOrders, component: <ManageOrders ordersType="Sent" /> },
  { path: Paths.deleteAccount, component: <DeleteAccount /> },

  //employer
  { path: Paths.manageJobs, component: <ManageJobs /> },
  { path: Paths.updateJob, component: <UpdateJob /> },
  { path: Paths.postJob, component: <PostJob /> },

  //buyer
  { path: Paths.manageProjects, component: <ManageProjects /> },
  { path: Paths.updateProject, component: <UpdateProject /> },
  { path: Paths.postProject, component: <PostProject /> },
  { path: Paths.orderDetail, component: <OrderDetail /> },

  { path: Paths.sentOffers, component: <SentOffers /> },

  // subscription (accessible to any logged-in user)
  { path: Paths.subscriptionPlans, component: <SubscriptionPlans /> },
  { path: Paths.subscriptionSuccess, component: <SubscriptionSuccess /> },
  { path: Paths.subscriptionCancel, component: <SubscriptionCancel /> },
];

export const SellerRoutes = [
  { path: Paths.payments, component: <Payment /> },
  { path: Paths.earnings, component: <Earnings /> },

  { path: Paths.manageGigs, component: <ManageGigs /> },
  { path: Paths.gigCreation, component: <GigCreation /> },
  { path: Paths.updateGig, component: <UpdateGig /> },
  { path: Paths.sentOffers, component: <SentOffers /> },
  {
    path: Paths.sellerOrders,
    component: <ManageOrders ordersType="Received" />,
  },
  { path: Paths.sellerOrderDetail, component: <SellerOrderDetail /> },
];

export const PublicRoutes = [
  { path: Paths.signUp, component: <SignUp /> },
  { path: Paths.signIn, component: <SignIn /> },
  { path: Paths.forgetPassword, component: <Forgetpassword /> },
  { path: Paths.subscriptionPlans, component: <SubscriptionPlansPublic /> },
];

export const commonRoutes = [
  { path: Paths.home, component: <Home /> },
  { path: Paths.mobileSso, component: <MobileSso /> },
  { path: Paths.faq, component: <FAQ /> },
  { path: Paths.error, component: <Error404 /> },
  { path: Paths.profile, component: <Profile /> },
  { path: Paths.viewGigs, component: <ViewGigs /> },
  { path: Paths.gigDetail, component: <GigDetail /> },
  //employer
  { path: Paths.jobDetail, component: <JobDetail /> },
  //buyer
  { path: Paths.projectDetail, component: <ProjectDetail /> },
  { path: Paths.legalTOS, component: <LegalTOS /> },
  { path: Paths.legalPP, component: <LegalPP /> },
  { path: Paths.legalPTOS, component: <LegalPTOS /> },
  { path: Paths.legalNDP, component: <LegalNDP /> },

  // SEO landing pages
  { path: Paths.servicesCategory, component: <CategoryPage /> },
  { path: Paths.servicesSubcategory, component: <CategoryPage /> },
];

export const EmployerRoutes = [
  { path: Paths.employer, component: <EmployerDashboard /> },
  { path: Paths.settings, component: <Settings /> },

  { path: Paths.inbox, component: <Inbox /> },
  { path: Paths.favourites, component: <Favourites /> },
  { path: Paths.JobCreation, component: <PostJob /> },
  { path: Paths.manageJobs, component: <ManageJobs /> },
  { path: Paths.updateJob, component: <UpdateJob /> },
  { path: Paths.payments, component: <Payment /> },
  { path: Paths.earnings, component: <Earnings /> },
  { path: Paths.incomingCandidates, component: <IncomingCandidates /> },
  {
    path: Paths.sellerOrders,
    component: <ManageOrders ordersType="Received" />,
  },
  { path: Paths.sentOffers, component: <SentOffers /> },

  // subscription
  { path: Paths.subscriptionPlans, component: <SubscriptionPlans /> },
  { path: Paths.subscriptionSuccess, component: <SubscriptionSuccess /> },
  { path: Paths.subscriptionCancel, component: <SubscriptionCancel /> },
];